import api from "./api";

export interface DashboardFinanceiroResponse {
  total_receita: string;
  total_clientes: number;
  pagamentos_pendentes: {
    quantidade: string;
    valor_total: string;
  };
  top_5: {
    nome: string;
    valor: number;
  }[];
  proporcao_pagamento: {
    pago_percent: number;
    pendente_percent: number;
  };
  receita_por_mes: {
    [mes: string]: number;
  };
}

const getDashboardFinanceiro = async () => {
  const response = await api.get<DashboardFinanceiroResponse>(
    "/api/dashboard-financeiro/"
  );

  return response.data;
};

export const dashboardFinanceiroService = {
  getDashboardFinanceiro,
};
